import { GetStaticProps } from "next";
import { Params } from "next/dist/server/router";

import { getRestaurants } from "../../../api/restaurants/getRestaurants";
import { RestaurantItemType } from "../../../api/types/restaurant.type";
import Header from "../../../components/layout/Header";
import RestaurantMapPage from "../../../components/Menu/Restaurants/RestaurantMapPage";
import { translationsContent } from "../../../localization/translations";
import { useLanguage } from "../../../store/lang.context";
import { translate } from "../../../utils/translate";

interface Props {
  restaurants: RestaurantItemType[];
}

export const getStaticProps: GetStaticProps<Props, Params> = async () => {
  const restaurants = await getRestaurants(300, "nl");

  return {
    props: {
      restaurants:
        restaurants.success && restaurants.data ? restaurants.data.results : [],
    },
  };
};

const RestaurantsPage = ({ restaurants }: Props) => {
  const { language } = useLanguage();
  return (
    <Header
      title={`EatSalad - ${translate(
        translationsContent,
        "restaurantsHeader",
        language
      )}`}
      description="Salade sur mesure à emporter et en livraison | Eat Salad"
      noindex={false}
      nofollow={false}
    >
      <RestaurantMapPage restaurants={restaurants} />
    </Header>
  );
};

export default RestaurantsPage;
